export const FIREBASE_PROJECT_ID: string = "gb-sample-ui-qa";
export const FIREBASE_API_KEY: string = "AIzaSyCcD6_xIkupzjgSO_Z4WwpP7e11mm1Wkdo";